import { render } from "./Repository.vue?vue&type=template&id=40afaf59&scoped=true"
import script from "./Repository.vue?vue&type=script&lang=js"
export * from "./Repository.vue?vue&type=script&lang=js"

import "./Repository.vue?vue&type=style&index=0&id=40afaf59&scoped=true&lang=css"

import exportComponent from "D:\\phpstudy_pro\\data.yuandiansiyu.com\\platform_frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40afaf59"]])

export default __exports__